import script from "./TagCloudSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TagCloudSection.vue?vue&type=script&setup=true&lang=js"

import "./TagCloudSection.vue?vue&type=style&index=0&id=432f70d4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-432f70d4"]])

export default __exports__